<div class="container-blog-slide">
    <h3>{{title}}</h3>
    <app-empty-component *ngIf="!system.attributes.can_receive || emptyBlog"
        text="{{ 'En esta sección, destacamos artículos de nuestro blog que hablan sobre ' + (system.attributes.name ? system.attributes.name : 'los métodos de intercambio') + ' y sus usos.' }}">
    </app-empty-component>
    <app-help-card-slide *ngIf="system.attributes.can_receive && !emptyBlog"
        [helpCenterModel]="postsGhostBySystem"></app-help-card-slide>
</div>
